import { Ng2StateDeclaration } from '@uirouter/angular';
import { AppearanceModuleSideListOptions } from '@fi-app/appearance/module-side-list-options';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IAppearanceSidebarStateModel } from '@fi-app/appearance/appearance';

export const FiAppearanceSidebarState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.Sidebar._name,
    url: '/Sidebar',
    abstract: true,
    component: FiAbstractStateComponent,
    resolve: {
        appearanceSidebarStateModel: [FiAppearanceSidebarStateResolveModel],
    },
};

export function FiAppearanceSidebarStateResolveModel(): IAppearanceSidebarStateModel {
    return {
        modulePreviewTemplateName: AppearanceModuleSideListOptions[0].previewTemplateName,
    };
}
